<template>
    <div class="my-10 mx-auto md:w-9/12 lg:w-7/12 ">
        <div class="h-full p-10 bg-white border rounded m-2">
            <h1 class="text-2xl mb-4 text-center">Contact Us</h1>
            <img class="m-auto min-h-[250px] max-h-[500px]" src="@/assets/contact_us.jpg" alt="">
            <p>We’re here to help!</p>


            <p class="my-2">
                If you have any questions, feedback, or concerns, feel free to reach out to us at <b> contact@nowrss.com</b>
            </p>
            
            <p class="my-2">
                For any issues or if you need assistance, please contact our support team
            </p>

            <p class="my-2">
                Our team will get back to you as soon as possible.
            </p>
        </div>
        
        

        
        
    </div>
</template>
  
<script>

export default {
    name: 'ContactUs',
    components: {

    },
    async mounted(){

    },
    data () {
        return {

        }
    }, 
    methods: {
        getYear(){
           return new Date().getFullYear()
        }
    }
}
</script>
 
<style>

</style>
  
<div>

</div>



// WEBPACK FOOTER //
// src/pages/ContactUs.vue